import React from "react";
import { Sprout } from "lucide-react";
import ServicePage from "./ServicePage";
import waterblasting from "../../assets/images/jpg/waterblasting.jpeg";

const service = {
  title: "Washing & Water Blasting",
  icon: Sprout,
  image: waterblasting,
  description:
    "Professional outdoor washing and water blasting for driveways, paths, walls, patios, fences, and exterior surfaces.",
  longText:
    "Our washing and water blasting service removes dirt, moss, stains, and buildup from outdoor areas while keeping surfaces presentable and safer to use. We select the right pressure and approach for each material to deliver a clean finish.",
  points: [
    "Driveway and path cleaning",
    "Patio and deck washing",
    "Fence and wall cleaning",
    "Moss and grime removal",
    "Residential exterior cleaning",
    "Commercial outdoor cleaning",
  ],
};

export default function WashingWaterBlasting() {
  return <ServicePage service={service} />;
}
